document.addEventListener('DOMContentLoaded', function() {
  // Get all collapsible rows
  const collapsibleRows = document.querySelectorAll('.product__accordion details');
  
  // 추가된 부분: 페이지 로드시 첫번째 row를 열어둡니다
  // 원하는 row 번호로 변경 가능 (0은 첫번째, 1은 두번째...)
  const defaultOpenRow = collapsibleRows[0];  // 여기서 숫자를 변경하면 다른 row가 열립니다
  if (defaultOpenRow) {
    defaultOpenRow.setAttribute('open', '');
  }
  
  // 기존 코드: click 이벤트 처리
  collapsibleRows.forEach(row => {
    row.addEventListener('click', (event) => {
      if (event.target.closest('summary')) {
        event.preventDefault();
        
        collapsibleRows.forEach(otherRow => {
          if (otherRow !== row && otherRow.hasAttribute('open')) {
            otherRow.removeAttribute('open');
          }
        });
        
        if (!row.hasAttribute('open')) {
          row.setAttribute('open', '');
        }
      }
    });
  });
});